export default __webpack_public_path__ + "static/SaolText-Regular-ddf9cba591d93e9543b77422ab1a86c2.woff2";